import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'date-friendly',
  templateUrl: './date-friendly.component.html',
})
export class DateFriendlyComponent implements OnInit {
  @Input() value: Date;
  public noValue: boolean;
  public isToday: boolean;
  public isSameYear: boolean;

  constructor() { }

  ngOnInit() {
    if (!this.value) {
      this.noValue = true;
      return;
    }

    if (!(this.value instanceof Date)) {
      this.value = new Date(this.value);
    }

    const today = new Date();

    const valueClone = new Date(this.value.getTime());
    this.isToday = today.setHours(0, 0, 0, 0) === valueClone.setHours(0, 0, 0, 0);

    this.isSameYear = today.getFullYear() === valueClone.getFullYear();
  }
}
